/*
 * @Description: 企业展示-资讯列表
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:08
 * @LastEditTime: 2019-07-24 14:12:46
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 公告
export const listNotice = (params, pageN, size) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/news/getInfo`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageCmsInfoByNotice',
        pageNo: pageN,
        pageSize: size || 5
      }, params))
    }
  })
}
// 企业新闻
export const listComNews = (params, pageN, size) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/news/getInfo`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageCmsInfoByComNews',
        pageNo: pageN,
        pageSize: size || 5
      }, params))
    }
  })
}
// 行业动态
export const listIndustry = (params, pageN, size) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/cms/news/getInfo`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageCmsInfoByIndustry',
        pageNo: pageN,
        pageSize: size || 5
      }, params))
    }
  })
}

